// 9fbef606107a605d69c0edbcd8029e5d
import styled, { css } from 'styled-components';
import Col from '@tcp/core/src/components/common/atoms/Col';

export const StyledCol = styled(Col)`
  @media ${(props) => props.theme.mediaQuery.large} {
    display: block;
    margin-top: 36px;
    margin-bottom: 36px;
  }
`;

export const StyledImageBannerWrapper = styled.div`
  padding: 12px 0;
  display: flex;
  flex-wrap: wrap;
  gap: 20px 16px;
  .l2-image-link-brand-partners {
    max-width: 80px;
  }

  .l2-nav-link.l2-nav-link-brand-partners {
    padding: 4px 0 8px 0;
    justify-content: center;
  }

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    padding-left: 16px;
    gap: 16px 24px;
    .l2-image-link-brand-partners {
      max-width: 70px;
      flex-shrink: 0;
    }
  }
`;

export default css`
  .l2-image-brand-partners {
    height: 80px;
    width: 80px;
  }

  ${(props) =>
    props.isBrandPartnerHoverEffectEnabled
      ? `
    .l2-image-brand-partners:hover {
      box-shadow: 8px 4px 16px 0px #0000001f;
    }
      `
      : ``}

  @media ${(props) => props.theme.mediaQuery.mediumMax} {
    .l2-image-brand-partners {
      height: 70px;
      width: 70px;
    }
  }

  .l2-nav-header {
    display: flex;
    flex-direction: row;
    align-items: baseline;
    @media ${(props) => props.theme.mediaQuery.mediumMax} {
      background-color: ${(props) =>
        !props.shouldRenderMobileNavRedesignedView &&
        props.theme.brandSpecificStyles.NAV_CATEGORY_HEADING};
    }
  }

  .pill {
    background-color: ${(props) => props.theme.brandSpecificStyles.PROMO_BADGE_BACKGROUND_COLOR};
    text-transform: uppercase;
    padding: 4px 8px;
    border-radius: 12px;
    margin-left: 8px;
    height: fit-content;
  }
`;
